module.exports = __webpack_public_path__ + "img/1205.df566ab4.png";